import { RenderResult } from '@dojo/framework/core/interfaces';
import { create, tsx } from '@dojo/framework/core/vdom';
import * as css from './FAQ.m.css';
import * as commonCss from '../Common.m.css';

export interface FAQProperties {
	title: string;
}

export interface FAQChild {
	title: string;
	content: RenderResult;
}

const factory = create().properties<FAQProperties>().children<FAQChild[]>();

export const FAQ = factory(function FAQ({ children, properties, id }) {
	const { title } = properties();
	const radioGroupName = `faq-group-${id}`;

	return (
		<div classes={[css.root, commonCss.smallerContentWrapper]}>
			<h2 classes={css.title}>{title}</h2>
			{children().map(({ title, content }, index) => {
				const isDefaultChecked = index === 0 ? 'true' : undefined;
				const radioId = `${radioGroupName}-${index}`;
				return (
					<div classes={css.item}>
						<label for={radioId}>
							<h3 classes={css.itemTitle}>
								<span>{title}</span>
								<i classes="icon-chevron-down"></i>
							</h3>
						</label>
						<input
							id={radioId}
							classes={css.itemRadio}
							type="radio"
							name={radioGroupName}
							checked={isDefaultChecked as any} // typings for checked are incorrect
						/>
						<div classes={css.itemContent}>{content}</div>
					</div>
				);
			})}
		</div>
	);
});

export default FAQ;
